module.exports = __webpack_public_path__ + "img/FT.8d3aecc8.png";